// clarity.service.ts
import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ClarityService {
  private _document = inject(DOCUMENT);

  /**
   * Inicializa el script de Microsoft Clarity.
   * El script solo se inyectará si la variable `clarityId` está definida
   * en el fichero de entorno correspondiente (ej. environment.prod.ts).
   */
  public init(): void {
    const clarityId = environment.clarityId;

    // Si no hay ID, no hacemos nada.
    if (!clarityId) {
      return;
    }

    const script = this._document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${clarityId}");
    `;
    this._document.head.appendChild(script);
  }
}
